import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  convertInMonthNameFormat,
  highlightMultipleTexts,
  stripHtml,
  cleanHTML
} from "../utils/helper";
import { ROUTES, AUTO, PRESS, PET } from "../assets/constant";
import { memo } from "react";

export const AutoCard = memo(
  ({
    item,
    handleFavourite,
    manufacturer_or_make,
    component,
    model,
    model_year
  }) => {
    const reportedDate = convertInMonthNameFormat(item?.report_received_date);
    const path = ROUTES.RECALL_DETAILS.replace(":type", AUTO).replace(
      ":id",
      item?.id
    );
    return (
      <div className="recalllistcard">
        <Link
          to={`${ROUTES.DASHBOARD}/${path}`}
          style={{ textDecoration: "none" }}>
          <div className="card-details">
            <span className="card-title">
              {highlightMultipleTexts(item?.recall_title, [
                manufacturer_or_make ?? "",
                component ?? "",
                model ?? "",
                model_year ?? ""
              ])}
            </span>
            <span
              style={{
                flex: "0 0 auto",
                marginLeft: "10px",
                fontSize: "12px"
              }}>
              {reportedDate}
            </span>
          </div>
          <div className="row">
            <h3 className="card-summary">
              {highlightMultipleTexts(
                stripHtml(item?.summary || ""),
                [
                  manufacturer_or_make ?? "",
                  component ?? "",
                  model ?? "",
                  model_year ?? ""
                ]
              )}
            </h3>
          </div>
        </Link>
        <div className="row">
          <button
            className="favorite-button"
            onClick={() => handleFavourite(item)}>
            {item?.is_favourite && <i className="fa fa-star"></i>}
            {!item?.is_favourite && <i className="fa-regular fa-star"></i>}
            Mark as favourite
          </button>
        </div>
      </div>
    );
  }
);

AutoCard.propTypes = {
  item: PropTypes.object.isRequired,
  handleFavourite: PropTypes.func.isRequired,
  manufacturer_or_make: PropTypes.string,
  component: PropTypes.string,
  model: PropTypes.string,
  model_year: PropTypes.string
};

export const FoodAndMedicineCard = memo(
  ({ item, handleFavourite, type, classification, searchQuery }) => {
    const reportedDate = convertInMonthNameFormat(item?.report_date);
    const path = ROUTES.RECALL_DETAILS.replace(":type", type).replace(
      ":id",
      item?.id
    );
    return (
      <div className="recalllistcard">
        <Link
          to={`${ROUTES.DASHBOARD}/${path}`}
          style={{ textDecoration: "none" }}>
          <div className="card-details">
            <span className="card-title">
              {highlightMultipleTexts(item?.recall_title, [
                classification ?? "",
                searchQuery ?? ""
              ])}
            </span>
            <span
              style={{
                flex: "0 0 auto",
                marginLeft: "10px",
                fontSize: "12px"
              }}>
              {reportedDate}
            </span>
          </div>
          <div className="row">
            <h3 className="card-summary">
              {highlightMultipleTexts(item?.product_description, [
                classification ?? "",
                searchQuery ?? ""
              ])}
            </h3>
          </div>
        </Link>
        <div className="row">
          <button
            className="favorite-button"
            onClick={() => handleFavourite(item)}>
            {item?.is_favourite && <i className="fa fa-star"></i>}
            {!item?.is_favourite && <i className="fa-regular fa-star"></i>}
            Mark as favourite
          </button>
        </div>
      </div>
    );
  }
);
FoodAndMedicineCard.propTypes = {
  item: PropTypes.object.isRequired,
  handleFavourite: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  classification: PropTypes.string,
  searchQuery: PropTypes.string
};

export const PressCard = memo(({ item, handleFavourite, searchQuery }) => {
  const reportedDate = convertInMonthNameFormat(item?.RecallDate);
  const path = ROUTES.RECALL_DETAILS.replace(":type", PRESS).replace(
    ":id",
    item?.id
  );
  return (
    <div className="recalllistcard">
      <Link
        to={`${ROUTES.DASHBOARD}/${path}`}
        style={{ textDecoration: "none" }}>
        <div className="card-details">
          <span className="card-title">
            {highlightMultipleTexts(item?.RecallTitle, [searchQuery ?? ""])}
          </span>
          <span
            style={{ flex: "0 0 auto", marginLeft: "10px", fontSize: "12px" }}>
            {reportedDate}
          </span>
        </div>
        <div className="row">
          <h3 className="card-summary">
            {highlightMultipleTexts(item?.impact, [searchQuery ?? ""])}
          </h3>
        </div>
      </Link>
      <div className="row">
        <button
          className="favorite-button"
          onClick={() => handleFavourite(item)}>
          {item?.is_favourite && <i className="fa fa-star"></i>}
          {!item?.is_favourite && <i className="fa-regular fa-star"></i>}
          Mark as favourite
        </button>
      </div>
    </div>
  );
});

PressCard.propTypes = {
  item: PropTypes.object.isRequired,
  handleFavourite: PropTypes.func.isRequired,
  searchQuery: PropTypes.string
};

export const ChildrenAndCPCard = memo(
  ({ item, handleFavourite, type, searchQuery }) => {
    const reportedDate = convertInMonthNameFormat(item?.RecallDate);
    const path = ROUTES.RECALL_DETAILS.replace(":type", type).replace(
      ":id",
      item?.RecallId
    );
    return (
      <div className="recalllistcard">
        <Link
          to={`${ROUTES.DASHBOARD}/${path}`}
          style={{ textDecoration: "none" }}>
          <div className="card-details">
            <span className="card-title">
              {highlightMultipleTexts(item?.Title, [searchQuery ?? ""])}
            </span>
            <span
              style={{
                flex: "0 0 auto",
                marginLeft: "10px",
                fontSize: "12px"
              }}>
              {reportedDate}
            </span>
          </div>
          <div className="row">
            <h3 className="card-summary">
              {highlightMultipleTexts(cleanHTML(item?.Description), [searchQuery ?? ""])}
            </h3>
          </div>
        </Link>
        <div className="row">
          <button
            className="favorite-button"
            onClick={() => handleFavourite(item)}>
            {item?.is_favourite && <i className="fa fa-star"></i>}
            {!item?.is_favourite && <i className="fa-regular fa-star"></i>}
            Mark as favourite
          </button>
        </div>
      </div>
    );
  }
);

ChildrenAndCPCard.propTypes = {
  item: PropTypes.object.isRequired,
  handleFavourite: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  searchQuery: PropTypes.string
};

export const PetCard = memo(({ item, handleFavourite, searchQuery }) => {
  const reportedDate = convertInMonthNameFormat(item?.recall_date);
  const path = ROUTES.RECALL_DETAILS.replace(":type", PET).replace(
    ":id",
    item?.id
  );

  return (
    <div className="recalllistcard">
      <Link
        to={`${ROUTES.DASHBOARD}/${path}`}
        style={{ textDecoration: "none" }}>
        <div className="card-details">
          <span className="card-title">
            {highlightMultipleTexts(item?.recall_title, [
              searchQuery ?? ""
            ])}
          </span>
          <span
            style={{
              flex: "0 0 auto",
              marginLeft: "10px",
              fontSize: "12px"
            }}>
            {reportedDate}
          </span>
        </div>
        <div className="row">
          <h3 className="card-summary">
            {highlightMultipleTexts(
              item?.product_description || item?.reason_for_recall || "",
              [searchQuery ?? ""]
            )}
          </h3>
        </div>
      </Link>
      <div className="row">
        <button
          className="favorite-button"
          onClick={() => handleFavourite(item)}>
          {item?.is_favourite && <i className="fa fa-star"></i>}
          {!item?.is_favourite && <i className="fa-regular fa-star"></i>}
          Mark as favourite
        </button>
      </div>
    </div>
  );
});

PetCard.propTypes = {
  item: PropTypes.object.isRequired,
  handleFavourite: PropTypes.func.isRequired,
  searchQuery: PropTypes.string
};